import SubVisual from '@/components/SubVisual';
import SectionCont1 from '@/pages/intro/components/SectionCont1';
import SectionCont2 from '@/pages/intro/components/SectionCont2';
import SectionCont3 from '@/pages/intro/components/SectionCont3';
import SectionCont4 from '@/pages/intro/components/SectionCont4';
import { Util } from '@/utils/utils';
import { useIntro } from '@/pages/intro/hook/useIntro';
import useScrollReset from '@/hooks/useScrollReset';

const IntroPage = () => {
	useIntro(Util.linearFunc);
	useScrollReset();
	return (
		<main id="sub" className="sub intro">
			<SubVisual cate={'서비스 소개'} title={'브랜드 스토리'} />
			<SectionCont1 />
			<SectionCont2 />
			<SectionCont3 />
			<SectionCont4 />
		</main>
	);
};

export default IntroPage;
